import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { ABOUT } from "@/content/pages";

export default function About() {
  return (
    <PageShell testid="about-root" seo={{
      title: "About — Sema",
      description: ABOUT.mission,
      keywords: "about sema, semantic layer company, enterprise AI data",
      path: "/about",
    }}>
      <PageHero testid="about-h1" eyebrow="About"
        title="Give your data a vocabulary."
        subtitle={ABOUT.mission} />

      <section className="pb-12">
        <div className="mx-auto w-full max-w-3xl space-y-5 px-6">
          {ABOUT.story.map((p, i) => (
            <p key={i} className="text-base leading-relaxed text-muted-foreground">{p}</p>
          ))}
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto w-full max-w-6xl px-6">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">How we build</h2>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {ABOUT.principles.map((pr) => (
              <div key={pr.title} className="rounded-2xl border border-border/60 bg-card/50 p-6 backdrop-blur">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-accent/15 text-accent">
                  <LucideIcon name={pr.icon} className="h-5 w-5" />
                </span>
                <h3 className="mt-4 text-base font-semibold tracking-tight">{pr.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{pr.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-border/50 py-14">
        <div className="mx-auto flex w-full max-w-4xl flex-col items-stretch justify-around gap-8 px-6 sm:flex-row">
          {ABOUT.stats.map((m) => (
            <div key={m.label} className="text-center">
              <div className="font-mono text-4xl font-semibold tracking-tight text-accent">{m.stat}</div>
              <div className="mt-2 text-sm text-muted-foreground">{m.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 text-center">
        <div className="mx-auto max-w-2xl px-6">
          <h2 className="text-3xl font-semibold tracking-tight">Want to help build it?</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/careers"><Button variant="outline" className="rounded-full border-border/70 px-5 font-mono text-xs uppercase tracking-[0.2em]">See open roles</Button></Link>
            <Link to="/signup"><Button className="rounded-full bg-accent px-5 font-mono text-xs uppercase tracking-[0.2em] text-accent-foreground hover:bg-accent/90">Try Sema <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
